import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useNavigate } from "react-router-dom";
type FunctionalArea = {
  id: string;
  name: string;
  description: string;
};
const functionalAreas: FunctionalArea[] = [{
  id: "technical-architecture",
  name: "Technical Architecture",
  description: "System design, platform integration, APIs, and overall technical structure"
}, {
  id: "web3-integration",
  name: "Web3 Integration",
  description: "Smart contracts, wallets, tokenization, blockchain components"
}, {
  id: "user-experience",
  name: "User Experience (UX/UI)",
  description: "Interface design, user interactions, accessibility considerations"
}, {
  id: "compliance-governance",
  name: "Compliance & Governance",
  description: "Security, legal frameworks, participation rules, and data privacy"
}, {
  id: "ai-automation",
  name: "AI & Automation",
  description: "Giblet's AI functionalities, confirmation processes, and decision automation"
}, {
  id: "knowledge-management",
  name: "Knowledge Management",
  description: "Documentation, knowledge bases, process refinement"
}, {
  id: "branding",
  name: "Branding",
  description: "Visual identity, messaging, tone, and brand alignment within iSPAI"
}, {
  id: "value-proposition",
  name: "Value Proposition",
  description: "Defining Giblet's core value to users, stakeholders, and market positioning"
}];
const CallForSolutionsFunctionalArea = () => {
  const navigate = useNavigate();
  const [selectedArea, setSelectedArea] = useState<string | null>(null);
  const handleContinue = () => {
    if (selectedArea) {
      const selectedAreaName = functionalAreas.find(area => area.id === selectedArea)?.name || selectedArea;
      navigate("/call-for-solutions/bounty", {
        state: {
          selectedArea: selectedAreaName
        }
      });
    }
  };
  return <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" alt="iSPAI Logo" className="h-16 cursor-pointer" onClick={() => navigate("/engage")} />
      </div>

      <Card className="w-full max-w-3xl border border-gray-200">
        <CardContent className="p-6">
          <h2 className="text-2xl font-semibold text-center mb-6">Call for Solution - Select Functional Area</h2>
          
          <RadioGroup value={selectedArea || ""} onValueChange={setSelectedArea} className="space-y-4">
            {functionalAreas.map(area => <div key={area.id} className="flex items-start space-x-2 p-2 rounded-md hover:bg-gray-50">
                <RadioGroupItem value={area.id} id={area.id} className="mt-1" />
                <div className="flex-1">
                  <Label htmlFor={area.id} className="font-medium cursor-pointer flex items-center">
                    {area.name} <span className="text-gray-500 ml-2">–</span>
                  </Label>
                  <p className="text-gray-600 text-sm ml-2">{area.description}</p>
                </div>
              </div>)}
          </RadioGroup>
          
          <div className="flex justify-between mt-8">
            <Button variant="outline" onClick={() => navigate("/call-for-solutions")} className="border-gray-300">
              Back
            </Button>
            <Button onClick={handleContinue} disabled={!selectedArea} className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded">
              Continue
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
};
export default CallForSolutionsFunctionalArea;